import RootModel from 'structure-root-model'

/**
 * ApplicationSecretModel Class
 *
 * @public
 * @class ApplicationSecretModel
 */
export default class ApplicationSecretModel extends RootModel {

  /**
   * ApplicationSecretModel constructor
   *
   * @public
   * @constructor
   * @param {Object} options - Options
   */
  constructor(options = {}) {
    super(Object.assign({}, {
      table: 'application_secrets',
    }, options))
  }

}
